import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = ["100% Halal", "Late Night", "Smash Burgers", "Philly Melts", "Tres Tacos", "Loaded Poutine", "Made Fresh"];

export const BrandMarquee = () => {
  return (
    <section className="relative border-y border-white/8 bg-surface py-7 sm:py-9 overflow-hidden" aria-hidden="true">
      <Marquee speed={38} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="text-stroke font-display text-4xl sm:text-6xl font-semibold px-6 sm:px-10 whitespace-nowrap">
              {w}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-gold/70" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default BrandMarquee;
